<template>

    <tq-loader-container class="TQ_center"
                         :p_show-loader_b="!server_questEvent_c || !server_questBody_c || !server_gameStatus_c || !server_currentUserData_c || !server_questExplore_c"
                         :p_tq-loader_b="true">

        <div v-if="server_questEvent_c && server_questBody_c && server_gameStatus_c && server_currentUserData_c && server_questExplore_c && server_creatorData_c" class="TQ_padding_8px">

            <!-- title -->
            <div class="TQ_bg_white TQ_padding_8px TQ_margin_bottom_8px TQ_text_24px TQ_align_initial TQ_bg_purple_dark">
                <span class="TQ_text_capitalize"> {{ass_strings.oneWord_event[store_system_langCode_v.val]}} </span>
                - <div class="TQ_direction_rtl TQ_inline">{{format_date_YYYY_MM_DD_hh_mm_fs(server_questEvent_c.qev_startingDate_t)}}</div>
            </div>

            <!-- body -->
            <div class="TQ_bg_white">

                <!-- 1) event header -->
                <tq-card width="100%" max-width="1350px" margin="8px" class="TQ_selectable">

                    <!--title -->
                    <div class="TQ_padding_8px TQ_text_28px TQ_bg_purple_dark TQ_borderRadius_top TQ_text_capitalize">
                        <div>{{ass_strings.twoWords_basicInfo[store_system_langCode_v.val]}}</div>
                    </div>

                    <c_Creator_Events_Item_EventHeader
                        class="TQ_padding_8px"
                        :p_system_lang-code_e="store_system_langCode_v.val"
                        :p_current-user-data_c="server_currentUserData_c"
                        :p_quest-tickets_ac="server_questTickets_ac"
                        :p_quest-event_c="server_questEvent_c"

                        :pe_quest-event_update_f="server_questEvent_update_f"
                        :pe_quest-event_delete_f="server_questEvent_delete_f"
                    />

                </tq-card>

                <!-- 2) tickets -->
                <tq-card width="100%" max-width="1350px" margin="8px" class="TQ_selectable">

                    <!--title -->
                    <div class="TQ_padding_8px TQ_text_28px TQ_bg_purple_dark TQ_borderRadius_top TQ_grid_col_auto1fr">
                        <img :src="ass_img_tickets_w" class="TQ_width_24px TQ_margin_4px"/>
                        <div>{{ass_strings.oneWord_tickets[store_system_langCode_v.val]}}</div>
                    </div>

                    <c_-creator_-events_-item_-tickets
                        v-if="server_currentUserData_c && server_creatorMonthlyTickets_c && server_subPlanInfo_c"
                        :p_quest-explore_c="server_questExplore_c"
                        :p_quest-body_c="server_questBody_c"
                        :p_quest-event_c="server_questEvent_c"
                        :p_quest-tickets_ac="server_questTickets_ac"
                        :p_creator-monthly-tickets_c= server_creatorMonthlyTickets_c
                        :p_system_lang-code_e="store_system_langCode_v.val"
                        :p_users-data_by-user-id_c="server_usersData_byUserId"
                        :p_current-user-data_c="server_currentUserData_c"
                        :p_sub-plan-info_c="server_subPlanInfo_c"
                        :pe_route_open-new-window_f="route_openNewWindow_f"
                    />

                </tq-card>
                <div class="TQ_padding_16px"></div>

                <!-- 3) game status-->
                <tq-card width="100%" max-width="350px" margin="8px">

                    <!--title -->
                    <div class="TQ_padding_8px TQ_text_28px TQ_bg_purple_dark TQ_borderRadius_top TQ_grid_col_auto1fr">
                        <img :src="ass_img_dice_w" class="TQ_width_24px TQ_margin_4px"/>
                        <div>{{ass_strings.twoWords_gameStatus[store_system_langCode_v.val]}}</div>
                    </div>

                    <!-- body -->
                    <c_-creator_-events_-item_-game-status
                        :p_selected-observe-teams-id_as=selectedObserveTeamsId_as
                        :p_game-status_c="server_gameStatus_c"
                        :p_quest-body_c="server_questBody_c"
                        :p_quest-event_c="server_questEvent_c"
                        :p_creator-data_c="server_creatorData_c"
                        :p_system_lang-code_e="store_system_langCode_v.val"
                        :p_current-user-data_c="server_currentUserData_c"

                        :pe_choose-team-to-observe_f="m_toggleObserveTeam_f"
                        :pe_server_create-new-team_f="server_createNewTeam_f"
                        :pe_server_update-game-status_time-extensions_f="server_updateGameStatus_timeExtensions_f"
                        :pe_server_update-game-status_creator-set-start-time_f="server_updateGameStatus_creatorSetStartTime_f"
                        :pe_send-teams-media_f="m_sendTeamsMedia_f"

                    />


                </tq-card>

                <!-- 4) players location map -->
                <tq-card width="100%" :max-width="store_system_windowSizeType_ve.val < enum_screenSizesOptions_n.laptop ? '450px' : '550px'" margin="8px">

                    <!--title -->
                    <div class="TQ_padding_8px TQ_text_28px TQ_bg_purple_dark TQ_borderRadius_top TQ_grid_col_auto1fr">
                        <img :src="ass_img_gps_w" class="TQ_width_24px TQ_margin_4px"/>
                        <div>{{ass_strings.twoWords_playersLocations[store_system_langCode_v.val]}}</div>
                    </div>

                    <div class="TQ_bg_white">
                        <tq-leaflet-display
                            style="height: 480px;"
                            pb_map-uid_s="allPlayers"
                            :p_players-location_by-user-id_c="co_allObserveTeamsPlayersLocations_byUserId_c"
                            :pf_two-fingers-movement_b="true"
                        />
                    </div>

                </tq-card>

                <!-- 5) team status -->
                <tq-card width="100%" :max-width="store_system_windowSizeType_ve.val < enum_screenSizesOptions_n.laptop ? '400px' : '450px'" margin="8px">

                    <!--title -->
                    <div class="TQ_padding_8px TQ_text_28px TQ_bg_purple_dark TQ_borderRadius_top TQ_grid_col_auto1fr">
                        <img :src="ass_img_playersGroup_w" class="TQ_width_24px TQ_margin_4px"/>
                        <div>{{ass_strings.twoWords_teamStatus[store_system_langCode_v.val]}}</div>
                    </div>

                    <div v-if="co_teamsTabs_ac.length === 0" class="TQ_padding_16px TQ_text_20px">
                        {{ass_strings.threeWords_pleaseSelectTeam[store_system_langCode_v.val]}}
                    </div>

                    <!-- select team -->
                    <tq-tabs v-else
                             :p_tabs_ao="co_teamsTabs_ac"
                             p_att_s="gst_name_s"
                             p_tabs-class_s="TQ_padding_8px TQ_text_20px"
                             :p_system_lang-code_e="store_system_langCode_v.val"
                             :p_selected-tab-index_vn="selectedTabIndex_vs">

                        <!-- team status -->
                        <c_-creator_-events_-item_-war-room_-team-status
                            v-if="co_selectedTeamId_uid "
                            :key="selectedTabIndex_vs.val"

                            :p_system_lang-code_e="store_system_langCode_v.val"

                            :p_game-status_c="server_gameStatus_c"
                            :p_game-status_team_c="server_gameStatus_c.gs_teams_byTeamId[co_selectedTeamId_uid]"
                            :p_team-status_c="server_teamsStatus_byTeamId_c[co_selectedTeamId_uid]"
                            :p_quest-body_c="server_questBody_c"
                            :p_quest-event_c="server_questEvent_c"
                            :p_players-data_by-user-id_c="server_usersData_byUserId"
                            :p_player-more-info_by-user-id_c="server_playersMoreInfo_byUserId_c"

                            :pe_game-status_team_update_f="serverOngoing_gameStatus_team_update_f"
                            :pe_game-status_team_delete_f="serverOngoing_gameStatus_team_delete_f"
                            :pe_game-status-and-team-status_update_f="serverOngoing_teamStatus_and_gameStatus_update_f"
                        />

                    </tq-tabs>
                </tq-card>

                <!-- 6) chat -->
                <tq-card width="100%" max-width="450px" margin="8px"
                         v-if="server_questBody_c.qb_metadata_c.qbm_quest_supportChat_b">

                    <!--title -->
                    <div class="TQ_padding_8px TQ_text_28px TQ_bg_purple_dark TQ_borderRadius_top TQ_grid_col_auto1fr">
                        <img :src="ass_img_chat_w" class="TQ_width_24px TQ_margin_4px"/>
                        <div>{{ass_strings.twoWords_TeamChat[store_system_langCode_v.val]}}</div>
                    </div>

                    <div v-if="co_teamsTabs_ac.length === 0" class="TQ_padding_16px TQ_text_20px">
                        {{ass_strings.threeWords_pleaseSelectTeam[store_system_langCode_v.val]}}
                    </div>

                    <!-- select team -->
                    <tq-tabs v-else
                             class="TQ_borderRadius_bottom "
                             :p_tabs_ao="co_teamsTabs_ac"
                             :p_tabs-notification_by-tab-index_n="co_chatNotification_byTabsIndex_n"
                             p_att_s="gst_name_s"
                             p_tabs-class_s="TQ_padding_8px TQ_text_20px"
                             :p_system_lang-code_e="store_system_langCode_v.val"
                             :p_selected-tab-index_vn="selectedTabIndex_vs">

                        <div class="TQ_grid_row_1frAuto TQ_height_450px">

                            <div ref="ref_chatMessages" class="TQ_align_initial TQ_text_18px TQ_scrollable TQ_padding_8px">

                                <tq-chat_messages
                                    :key="co_selectedTeamId_uid"
                                    :p_current-user_c="server_currentUserData_c"
                                    :p_creator-id_uid="server_questEvent_c.qev_creatorId_uid"
                                    :p_system-lang-code_e="store_system_langCode_v.val"

                                    :p_messages_by-send-time_c="server_messages_byTeamId_bySendTime_c[co_selectedTeamId_uid]"
                                    :p_all-player-join-time_by-player-id_c="co_getPlayersIds_byUserId_c"
                                    :p_msg-show-translate_by-msg-time_b="store_chat_msgShowTranslate_v_byMsgTime_b.val"

                                    :p_show-translation_b="server_questBody_c.qb_metadata_c.qbm_quest_supportChatTranslate_b"

                                    :pe_translate-msg_f="m_chat_translate_f"
                                    :pe_mounted_f="m_chat_setScrollingListener"/>

                            </div>


                            <tq-chat_input-bar
                                :key="co_selectedTeamId_uid"
                                :p_current-user_c="server_currentUserData_c"
                                :p_system-lang-code_e="store_system_langCode_v.val"

                                :p_saved-messages_by-timestamp_c="server_savedMessages_byTimestamp_c"

                                :p_bottom-notification_n="chatBottomNotification_n"
                                :p_chat-scroll-to-bottom_b="chatScrollToBottom_b"


                                :pe_set-saved-message_f="(timestamp_t, savedMsg_c, cb_f) => {server_ongoingSavedMsg_set_f(server_questEvent_c, timestamp_t, savedMsg_c, cb_f)}"
                                :pe_send-message_f="m_chat_sendMsg_f"
                                :pe_send-message-to-all_f="m_chat_sendMsgToAll"
                                :pe_scroll-down_f="m_chat_scrollDown_f"/>

                        </div>

                    </tq-tabs>

                </tq-card>

                <!-- 7) map -->
                <tq-card width="100%" max-width="450px" margin="8px"
                         v-if="server_questBody_c.qb_metadata_c.qbm_quest_supportMapMissions_b">

                    <!--title -->
                    <div class="TQ_padding_8px TQ_text_28px TQ_bg_purple_dark TQ_borderRadius_top TQ_grid_col_auto1fr">
                        <img :src="ass_img_map_w" class="TQ_width_24px TQ_margin_4px"/>
                        <div>{{ass_strings.twoWords_questMap[store_system_langCode_v.val]}}</div>
                    </div>

                    <!-- select teams -->
                    <div v-if="co_teamsTabs_ac.length === 0" class="TQ_padding_16px TQ_text_20px">
                        {{ass_strings.threeWords_pleaseSelectTeam[store_system_langCode_v.val]}}
                    </div>

                    <tq-tabs v-else
                             class=" TQ_margin_4px "

                             :p_tabs_ao="co_teamsTabs_ac"
                             :p_tabs-notification_by-tab-index_n="co_mapNotification_byTabsIndex_n"

                             p_att_s="gst_name_s"
                             p_tabs-class_s="TQ_padding_8px TQ_text_20px"

                             :p_system_lang-code_e="store_system_langCode_v.val"
                             :p_selected-tab-index_vn="selectedTabIndex_vs">

                        <c_-creator_-events_-item_-map
                            :key="co_selectedTeamId_uid"
                            class="TQ_margin_top_4px"

                            :p_system_lang-code_e="store_system_langCode_v.val"
                            :p_quest-body_c="server_questBody_c"

                            :p_show-overlay-images-index_a="co_getFinishMapMissionsIndexes_an"
                            :p_ts_riddles_by-riddle-id_c="server_ts_mapMissions_byTeamId_byRiddleId_c[co_selectedTeamId_uid]"
                            :p_ts_last-riddles_by-riddle-id_c="server_ts_mapLastMissions_byTeamId_byRiddleId_c[co_selectedTeamId_uid]"

                            :p_current-points_by-riddle-id_n="missionsPoints_byTeamId_byType_byRiddleId_n[co_selectedTeamId_uid] ? missionsPoints_byTeamId_byType_byRiddleId_n[co_selectedTeamId_uid][enum_subCollection_teamStatus.MAP_MISSIONS] : {}"
                            :p_gst_missions-arrangement-index_n="co_currentTeamIndex_n"
                            :p_map-last-missions-notification_n="co_mapLastMissionsNotification_byTabsIndex_n[selectedTabIndex_vs.val]"

                            :p_players-location_by-user-id_c="mapPlayersLocations_byTeamId_byUserId_c[co_selectedTeamId_uid]"

                            :pe_update_riddles_-lock-status_f="m_userEvent_updateMapMission_LockStatus"
                            :pe_update_last-riddles_-lock-status_f="m_userEvent_updateMapLastMission_LockStatus"

                        />

                    </tq-tabs>

                </tq-card>

                <!-- 8) missions -->
                <tq-card width="100%" max-width="450px" margin="8px"
                         v-if="server_questBody_c.qb_metadata_c.qbm_quest_supportListMissions_b">

                    <!--title -->
                    <div class="TQ_padding_8px TQ_text_28px TQ_bg_purple_dark TQ_borderRadius_top TQ_grid_col_auto1fr">
                        <img :src="ass_img_target_w" class="TQ_width_24px TQ_margin_4px"/>
                        <div>{{ass_strings.twoWords_missionsList[store_system_langCode_v.val]}}</div>
                    </div>


                    <!-- body -->
                    <div v-if="co_teamsTabs_ac.length === 0" class="TQ_padding_16px TQ_text_20px">
                        {{ass_strings.threeWords_pleaseSelectTeam[store_system_langCode_v.val]}}
                    </div>
                    <tq-tabs v-else
                             class=" TQ_margin_4px "

                             :p_tabs_ao="co_teamsTabs_ac"
                             :p_tabs-notification_by-tab-index_n="co_missionsNotification_byTabsIndex_n"
                             p_att_s="gst_name_s"
                             p_tabs-class_s="TQ_padding_8px TQ_text_20px"
                             :p_system_lang-code_e="store_system_langCode_v.val"
                             :p_selected-tab-index_vn="selectedTabIndex_vs">

                        <c_-creator_-events_-item_-war-room_-side-missions
                            class="TQ_margin_top_4px"
                            :pp_team-status_c="server_teamsStatus_byTeamId_c[co_selectedTeamId_uid]"
                            :pp_game-status_c="server_gameStatus_c"

                            :p_missions-groups_ac="server_questBody_c.qb_missionsGroup_ac"
                            :p_team-status_missions_by-riddle-id_c="server_ts_listMissions_byTeamId_byRiddleId_c[co_selectedTeamId_uid]"
                            :p_missions-riddles_ac="server_questBody_c.qb_listMissions_ac"
                            :p_display_lang-code_e="server_questBody_c.cm_qb_getDisplayLangCode_e(store_system_langCode_v.val)"
                            :p_system_lang-code_e="store_system_langCode_v.val"
                            :pe_update_mission-riddle_-lock-status_f="m_userEvent_updateListMissions_LockStatus"
                            :p_qb_metadata_c="server_questBody_c.qb_metadata_c"
                        />


                    </tq-tabs>

                </tq-card>

                <!-- 9) card missions -->
                <tq-card width="100%" max-width="450px" margin="8px"
                         v-if="server_questBody_c.qb_metadata_c.qbm_quest_supportCardsMissions_b">

                    <!--title -->
                    <div class="TQ_padding_8px TQ_text_28px TQ_bg_purple_dark TQ_borderRadius_top TQ_grid_col_auto1fr">
                        <img :src="ass_img_cards_w" class="TQ_width_24px TQ_margin_4px"/>
                        <div>{{ass_strings.twoWords_cardsMissions[store_system_langCode_v.val]}}</div>
                    </div>

                    <!-- no teams -->
                    <div v-if="co_teamsTabs_ac.length === 0" class="TQ_padding_16px TQ_text_20px">
                        {{ass_strings.threeWords_pleaseSelectTeam[store_system_langCode_v.val]}}
                    </div>

                    <!-- all missions-->
                    <c_-creator_-events_-item_-cards-missions
                        ref="ref_cardsMissions"
                        v-else
                        :p_system_lang-code_e="store_system_langCode_v.val"
                        :p_team-id_uid="co_selectedTeamId_uid"
                        :p_quest-body_c="server_questBody_c"
                        :p_quest-event_c="server_questEvent_c"
                        :p_game-status_c="server_gameStatus_c"

                        :p_teams-tabs_ac="co_teamsTabs_ac"
                        :p_selected-tab-index_vn="selectedTabIndex_vs"

                        :pe_update-team-status_riddle-status_unlock_status="m_userEvent_updateCardsMission_LockStatus"
                    />


                </tq-card>

                <!-- 10) charts  -->
                <tq-card width="100%" max-width="1350px" margin="8px" v-if="server_teamsStatus_byTeamId_c[co_selectedTeamId_uid] && co_chartTabs_ao.length>0 && server_gameStatus_c.gs_teams_byTeamId[co_selectedTeamId_uid]">

                    <!--title -->
                    <div class="TQ_padding_8px TQ_text_28px TQ_bg_purple_dark TQ_borderRadius_top TQ_grid_col_auto1fr">
                        <img :src="ass_img_chart_w" class="TQ_width_24px TQ_margin_4px"/>
                        <div>{{ass_strings.oneWord_charts[store_system_langCode_v.val]}}</div>
                    </div>

                    <tq-tabs :p_selected-tab-index_vn="tqTabs_selectedTabIndex_chart_vl"
                             p_att_s="name"
                             :p_display_lang-code_e="store_system_langCode_v.val"
                             :p_tabs_ao="co_chartTabs_ao"
                             class="TQ_bg_gray4 TQ_borderBox"
                             p_padding-body_s="0 4px 4px 4px">

                        <!-- summary table -->
                        <tq-table
                            v-if="co_chartTabs_ao[tqTabs_selectedTabIndex_chart_vl.val].id === 0"
                            class="TQ_bg_white"

                            :rows="selectedObserveTeamsId_as"
                            :system-lang-code="store_system_langCode_v.val"
                            :display-search="true"
                            p_td-classes_s="TQ_padding_8px"
                            :columns="co_tableColumns_fo"
                        />

                        <!-- map missions -->
                        <c_-creator_-events_-item_-chart
                            v-if="co_chartTabs_ao[tqTabs_selectedTabIndex_chart_vl.val].id === 4"
                            class="TQ_bg_white TQ_padding_8px"
                            :p_quest-body_riddles_ac="server_questBody_c.qb_mapMissions_ac"
                            :p_quest-body_last-riddles_ac="server_questBody_c.qb_mapLastMissions_ac"
                            :p_team-status-riddles_by-team-id_by-riddle-id_c="server_ts_mapMissions_byTeamId_byRiddleId_c"
                            :p_team-status-last-riddles_by-team-id_by-riddle-id_c="server_ts_mapLastMissions_byTeamId_byRiddleId_c"
                            :p_gs_teams_by-team-id-c="co_gs_teams_byTeamsIdC"
                            :p_quest-event_c="server_questEvent_c"
                            :p_system_display-lang_e="server_questBody_c.cm_qb_getDisplayLangCode_e(store_system_langCode_v.val)"
                            :p_starting-time_by-team-id_t="co_startingTime_byTimeId_t"
                            :p_duration-in-minutes_n="server_questEvent_c.qev_durationInMinutes_n"
                        />

                        <!-- cards missions -->
                        <c_-creator_-events_-item_-chart
                            v-if="co_chartTabs_ao[tqTabs_selectedTabIndex_chart_vl.val].id === 1"
                            class="TQ_bg_white TQ_padding_8px"

                            :p_quest-body_riddles_ac="server_questBody_c.qb_cardsMissions_ac"
                            :p_quest-body_last-riddles_ac="[]"
                            :p_team-status-riddles_by-team-id_by-riddle-id_c="server_ts_cardsMissions_byTeamId_byRiddleId_c"
                            :p_team-status-last-riddles_by-team-id_by-riddle-id_c="{}"

                            :p_gs_teams_by-team-id-c="co_gs_teams_byTeamsIdC"
                            :p_quest-event_c="server_questEvent_c"
                            :p_system_display-lang_e="server_questBody_c.cm_qb_getDisplayLangCode_e(store_system_langCode_v.val)"
                            :p_starting-time_by-team-id_t="co_startingTime_byTimeId_t"

                            :p_duration-in-minutes_n="server_questEvent_c.qev_durationInMinutes_n"
                        />

                        <!-- mission chart -->
                        <c_-creator_-events_-item_-chart
                            v-if="co_chartTabs_ao[tqTabs_selectedTabIndex_chart_vl.val].id === 2"
                            class="TQ_bg_white TQ_padding_4px"
                            :p_quest-body_riddles_ac="server_questBody_c.qb_listMissions_ac"
                            :p_quest-body_last-riddles_ac="[]"
                            :p_team-status-riddles_by-team-id_by-riddle-id_c="server_ts_listMissions_byTeamId_byRiddleId_c"
                            :p_team-status-last-riddles_by-team-id_by-riddle-id_c="{}"

                            :p_gs_teams_by-team-id-c="co_gs_teams_byTeamsIdC"
                            :p_quest-event_c="server_questEvent_c"
                            :p_system_display-lang_e="server_questBody_c.cm_qb_getDisplayLangCode_e(store_system_langCode_v.val)"
                            :p_starting-time_by-team-id_t="co_startingTime_byTimeId_t"

                            :p_duration-in-minutes_n="server_questEvent_c.qev_durationInMinutes_n + server_gameStatus_c.gs_timeExtensionMinutes_n"
                        />

                        <!-- mission point chart -->
                        <tq-chart
                            v-if="co_chartTabs_ao[tqTabs_selectedTabIndex_chart_vl.val].id === 3"
                            :datasets="co_missionChart_datasets"
                            :p_labels_as="co_missionChart_labels"
                            type="bar"
                            class="TQ_bg_white TQ_padding_4px TQ_maxWidth_500px TQ_center"
                            :height="160"
                        />

                    </tq-tabs>

                </tq-card>

            </div>

            <!-- 11) display files  -->
            <div>

                <!-- Polygon Quest-->
                <div v-if="false" class="TQ_selectable" >
                    <table style="border : 1px solid black; border-collapse: collapse; display: inline-block;">

                        <tr style="background: white; font-size: 20px; border : 1px solid black;">

                            <td v-for="(ts_missions_byRiddleId_c, teamId_uid) in server_ts_listMissions_byTeamId_byRiddleId_c" style="padding: 8px; border : 1px solid black;">
                                "{{server_gameStatus_c.gs_teams_byTeamId[teamId_uid].gst_name_s}}"
                            </td>
                        </tr>



                        <tr v-for="qb_missions_c in server_questBody_c.qb_listMissions_ac" style="padding: 8px; border : 1px solid black;" >


                            <td v-for="(ts_missions_byRiddleId_c, teamId_uid) in server_ts_listMissions_byTeamId_byRiddleId_c" style="padding: 8px; border : 1px solid black;">

                                <div v-if="ts_missions_byRiddleId_c[qb_missions_c.qbr_riddleId_n]">
                                    <div v-for="(rs_unlockData_c, index) in ts_missions_byRiddleId_c[qb_missions_c.qbr_riddleId_n].rs_unlock_byLockId_c" >

                                        <div v-if="['IMAGE', 'VIDEO'].includes(rs_unlockData_c.rsud_lockType_e) && rs_unlockData_c.rsud_imgFile_c" >
                                            <a :href="rs_unlockData_c.rsud_imgFile_c.fi_url_s"> {{qb_missions_c.qbr_title_blc_s['iw']}}</a>
                                        </div>
                                    </div>
                                </div>
                            </td>

                        </tr>

                    </table>
                </div>

                <!-- Group Missions -->
                <div v-if="false" class="TQ_selectable">

                    <div v-for="(ts_missions_byRiddleId_c, teamId_uid) in server_ts_listMissions_byTeamId_byRiddleId_c"
                         style="background: white; margin: 8px; padding: 8px; text-align: initial; border-radius: 5px;">

                        <div style="font-size: 40px;  font-weight: bold; text-decoration-line:  underline;">
                            {{server_gameStatus_c.gs_teams_byTeamId[teamId_uid].gst_name_s}}
                        </div>


                        <div v-for="qb_missionsGroup_c in server_questBody_c.qb_missionsGroup_ac" style="padding: 8px; background: #EAE6E1">
                            <div style="font-size: 28px;">
                                {{qb_missionsGroup_c.qbmg_name_byLangCode_s['en']}}
                            </div>
                            <div v-for="riddleId_n in qb_missionsGroup_c.qbmg_riddlesIds_an" v-if="ts_missions_byRiddleId_c[riddleId_n]" style="display: inline-block">

                                <div v-for="(rs_unlockData_c, index) in ts_missions_byRiddleId_c[riddleId_n].rs_unlock_byLockId_c" style="display: inline-block;">

                                    <div v-if="['IMAGE', 'VIDEO'].includes(rs_unlockData_c.rsud_lockType_e) && rs_unlockData_c.rsud_imgFile_c" style="padding: 16px; display: inline-block; margin: 4px; background: white;">
                                        <a :href="rs_unlockData_c.rsud_imgFile_c.fi_url_s"> {{co_listMissions_byRiddleId_c[riddleId_n].qbr_title_blc_s['en']}} - {{index}}</a>
                                    </div>
                                </div>

                            </div>
                        </div>



                    </div>
                </div>

                <!-- cards Missions -->
                <div v-if="false" class="TQ_selectable">


                    <div v-for="(ts_missions_byRiddleId_c, teamId_uid) in server_ts_cardsMissions_byTeamId_byRiddleId_c "
                         style="background: white; margin: 8px; padding: 8px; text-align: initial; border-radius: 5px;">

                        <div style="font-size: 40px;  font-weight: bold; text-decoration-line:  underline;">
                            {{server_gameStatus_c.gs_teams_byTeamId[teamId_uid].gst_name_s}}
                        </div>

                        <div v-for="(riddle_c, riddleId_n) in ts_missions_byRiddleId_c">

                            <div v-for="(rs_unlockData_c, index) in riddle_c.rs_unlock_byLockId_c">

                                <div v-if="['IMAGE', 'VIDEO'].includes(rs_unlockData_c.rsud_lockType_e) && rs_unlockData_c.rsud_imgFile_c" style="padding: 8px; display: inline-block; margin: 4px; background: white;">

                                    <a :href="rs_unlockData_c.rsud_imgFile_c.fi_url_s" >
                                        <div v-if="co_cardsMissions_byRiddleId_c[riddleId_n]">{{co_cardsMissions_byRiddleId_c[riddleId_n].qbr_title_blc_s['en']}} - {{index}}</div>
                                        <div v-else>Mission</div>
                                    </a>
                                </div>
                            </div>

                        </div>

                    </div>

                </div>

                <!-- Map Missions -->
                <div v-if="false" class="TQ_selectable">

                    <div v-for="(ts_missions_byRiddleId_c, teamId_uid) in server_ts_mapMissions_byTeamId_byRiddleId_c"
                         style="background: white; margin: 8px; padding: 8px; text-align: initial; border-radius: 5px;">

                        <div style="font-size: 40px;  font-weight: bold; text-decoration-line:  underline;">
                            {{server_gameStatus_c.gs_teams_byTeamId[teamId_uid].gst_name_s}}
                        </div>

                        <div v-for="(riddle_c, riddleId_n) in ts_missions_byRiddleId_c">

                            <div v-for="(rs_unlockData_c, index) in riddle_c.rs_unlock_byLockId_c">

                                <div v-if="['IMAGE', 'VIDEO'].includes(rs_unlockData_c.rsud_lockType_e) && rs_unlockData_c.rsud_imgFile_c" style="padding: 8px; display: inline-block; margin: 4px; background: white;">

                                    <a :href="rs_unlockData_c.rsud_imgFile_c.fi_url_s" >
                                        <div v-if="co_listMissions_byRiddleId_c[riddleId_n]">{{co_listMissions_byRiddleId_c[riddleId_n].qbr_title_blc_s['en']}} - {{index}}</div>
                                        <div v-else>Mission</div>
                                    </a>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>

                <!-- users -->
                <div v-if="false" class="TQ_selectable">

                    <div v-for="(gs_team_c, teamId_uid) in server_gameStatus_c.gs_teams_byTeamId"
                         v-if="gs_team_c.gst_playerStartTime_t != null"
                         style="background: white; margin: 8px; padding: 8px; text-align: initial; border-radius: 5px;">

                        <div style="font-size: 20px;">
                            {{gs_team_c.gst_name_s}}
                        </div>
                        <div>
                            {{format_date_YYYY_MM_DD_hh_mm_fs(gs_team_c.gst_playerStartTime_t)}}
                        </div>
                        <hr>
                        <table style="border:1px solid black; collapse: true">
                            <tr v-for="(qst_player_c, key, index) in gs_team_c.gst_players_byUserId_c" style="border:1px solid black">
                                <td style="border:1px solid black; padding: 8px">
                                    {{index}}
                                </td>
                                <td v-if="server_usersData_byUserId[qst_player_c.gstp_playerId_uid]" style="border:1px solid black; padding: 8px">
                                    {{server_usersData_byUserId[qst_player_c.gstp_playerId_uid].ud_name_s}}
                                </td>
                                <td v-if="server_usersData_byUserId[qst_player_c.gstp_playerId_uid]" style="border:1px solid black; padding: 8px">
                                    {{server_usersData_byUserId[qst_player_c.gstp_playerId_uid].ud_email_s}}
                                </td>
                            </tr>
                        </table>




                    </div>
                </div>

            </div>

        </div>
    </tq-loader-container>

</template>

<script>

    import c_Creator_Events_Item_EventHeader from "./v_Creator_Events_Item/c_Creator_Events_Item_EventHeader";
    import {store_var, store_getStateValue_vo, store_setStateValue} from "../../../store";
    import {
        serverOngoing_teamStatus_vl_set_f,
        serverOngoing_chatMessage_send_f,
        serverOngoing_chatMessages_cl_set_f,
        serverOngoing_gameStatus_vl_set_f,
        serverOngoing_gameStatus_team_update_f,
        serverOngoing_teamStatus_update_f,
        serverOngoing_teamStatusSub_rsud_status_update_f,
        serverOngoing_chatMessage_read_f,
        serverOngoing_gameStatus_timeExtensions_update_f,
        serverOngoing_teamPlayersGeoLocation_cl_set_f,
        serverOngoing_teamPlayersGeoLocation_cl_remove_f,
        serverOngoing_gameStatus_team_delete_f,
        serverOngoing_teamStatus_subCollection_cl_get_f,
        serverOngoing_teamStatus_subCollection_cl_remove_f,
        serverOngoing_teamStatus_vl_remove_f,
        serverOngoing_chatMessages_cl_remove,
        serverOngoing_gameStatus_creatorSetStartTime_update_f,
        serverOngoing_chatMessage_receive_f,
        serverOngoing_playerMoreInfo_vl_set_f,
        serverOngoing_createNewTeam_f,
        serverOngoing_savedMsg_getOnce_f,
        serverOngoing_savedMsg_set_f,
        serverOngoing_playerMoreInfo_vl_remove_f,
        serverOngoing_gameStatus_vl_remove_f,
        serverOngoing_chatMessage_translate_f,
    } from "../../../scripts/Server/S_ServerOngoing";
    import {
        serverBig_questBody_once_fp, serverBig_questExplore_once_f,
    } from "@/scripts/Server/S_ServerFirestore";
    import {
        helper_finishRiddle_fb,
        helper_getRiddleWithRiddleId_fc,
        helper_getFinishDuration_fs,
        helper_getRiddleIndexWithRiddleId_fn,
    } from "@/scripts/S_Helper";
    import ToggleSwitch from "../../../components/basic/TqToggleSwitch";
    import TqToggleDiv from "../../../components/basic/TqToggleDiv";
    import TqCard from "../../../components/basic/TqCard";
    import c_Creator_Events_Item_Chart from "./v_Creator_Events_Item/c_Creator_Events_Item_Chart";
    import TqLoaderContainer from "../../../components/basic/TqLoaderContainer";
    import TqTabs from "../../../components/basic/TqTabs";
    import C_Creator_Events_Item_WarRoom_SideMissions
        from "./v_Creator_Events_Item/c_Creator_Events_Item_SideMissions";
    import C_Creator_Events_Item_WarRoom_TeamStatus from "./v_Creator_Events_Item/c_Creator_Events_Item_TeamStatus";
    import TqChat_inputBar from "../../../components/complex/TqChat_inputBar";
    import TqChat_messages from "../../../components/complex/TqChat_messages";
    import {ass_strings} from "../../../../functions/src/shareCode/Share_Ass_Dictionary";
    import {
        server_questEvent_delete_f,
        server_questEvent_vl_set_f,
        server_questEvent_vl_remove_f,
        server_questTicket_vl_set,
        server_questTicket_vl_remove,
        server_questEvents_cl_set_f,
        server_questEvent_update_f,
        server_sendMail_fp,
        serverPre_subUserData_subscriptionPlanInfo_get_f,
        server_creatorMonthlyTickets_vl_set, server_creatorMonthlyTickets_vl_remove,
    } from "../../../scripts/Server/S_ServerPre";
    import TqEventStatusBar from "../../../components/basic/TqEventStatusBar";
    import TqTable from "../../../components/basic2/TqTable";
    import C_Creator_Events_Item_Map from "./v_Creator_Events_Item/c_Creator_Events_Item_Map";
    import TqChart from "../../../components/complex/TqChart";
    import {route_moveToRoute, route_openNewWindow_f} from "../../../router";
    import {
        ass_audio_notifyMissions,
        ass_img_cards_w,
        ass_img_chart_w,
        ass_img_chat_w, ass_img_dice_w, ass_img_dices_b, ass_img_edit2_b, ass_img_gps_w, ass_img_info_b, ass_img_info_w,
        ass_img_map_w, ass_img_playersGroup_w,
        ass_img_target_w, ass_img_tickets_b,
        ass_img_tickets_w,
    } from "../../../assets/scripts/Ass_Files";
    import {file_playAudio_f} from "../../../scripts/S_Files";
    import TqPopup from "../../../components/basic/TqPopup";
    import TqBtnApprove from "../../../components/basic2/TqBtnApprove";
    import TqSelectImage from "../../../components/mediaComponenets/TqSelectImage";
    import TqDropdown from "../../../components/basic/TqDropdown";
    import {
        obj_deepCopy_f2,
        obj_equals_fb,
        obj_forEach_f, obj_size_fn,
        obj_vFor_f,
    } from "../../../../functions/src/shareCode/Share_S_Obj";
    import {FB_Message, FB_SendEmail} from "../../../../functions/src/shareCode/Share_S_Classes";
    import {
        enum_lockTypes,
        enum_moveToOptions,
        enum_subCollection_teamStatus,
        enum_lockState, enum_screenSizesOptions_n,
        enum_eventsListenersNames, enum_questEventStartClockTypes_s, enum_missions_LocksType_s
    } from "../../../../functions/src/shareCode/Share_S_Enum";
    import {
        serverAuth_currentUserData_get_vl_fp,
        serverAuth_currentUserData_remove_vl_f,
        serverAuth_getOtherUserData_f
    } from "../../../scripts/Server/S_ServerAuth";
    import TqPickColor from "../../../components/basic2/TqPickColor";
    import TqLeafletDisplay from "../../../components/maps/TqLeafletDisplay";
    import {date_getTimePastInSeconds_fn, date_setTimeout} from "../../../scripts/S_Date";
    import C_Creator_Events_Item_GameStatus from "./v_Creator_Events_Item/c_Creator_Events_Item_GameStatus";
    import C_Creator_Events_Item_CardsMissions from "./v_Creator_Events_Item/c_Creator_Events_Item_CardsMissions";
    import C_Creator_Events_Item_Tickets from "./v_Creator_Events_Item/c_Creator_Events_Item_Tickets";
    import {eventListener_addEventListenerToObj} from "../../../scripts/S_EventListeners";
    import {gv_numbers} from "../../../../functions/src/shareCode/Share_Ass_GlobalVirables";
    import TqDisplayFile from "../../../components/mediaComponenets/TqDisplayFile";
    import {notification_notify2} from "../../../scripts/S_Notification";
    import {
        format_clockType_f,
        format_date_YYYY_MM_DD_hh_mm_fs,
        format_duration_hhmmss
    } from "../../../../functions/src/shareCode/Share_S_Format";
    import TqImage from "@/components/basic/TqImage";
    import {helper_getObjIndexInArray_fn} from "../../../../functions/src/shareCode/Share_S_Helper";
    import {FB_MapPlayerLocation} from "@/classes/client_classes";

    export default {
        name: "V_Creator_Events_Item",
        components: {
            TqImage,
            TqDisplayFile,
            C_Creator_Events_Item_Tickets,
            c_Creator_Events_Item_EventHeader,
            c_Creator_Events_Item_Chart,
            C_Creator_Events_Item_WarRoom_TeamStatus,
            C_Creator_Events_Item_WarRoom_SideMissions,
            C_Creator_Events_Item_CardsMissions,
            C_Creator_Events_Item_GameStatus,

            TqLeafletDisplay,
            TqPickColor,
            TqDropdown,
            TqSelectImage,
            TqBtnApprove,
            TqPopup,
            TqChart,
            C_Creator_Events_Item_Map,
            TqTable,
            TqEventStatusBar,

            TqTabs,
            TqCard,
            TqToggleDiv,
            ToggleSwitch,
            TqLoaderContainer,
            TqChat_messages,
            TqChat_inputBar,

        },
        data(){
            return {

                // local
                tabs_ao : [
                    {name_s: 'Basic Info',          id_n: 1,    img_s : ass_img_info_b},
                    {name_s: 'Tickets',             id_n: 2,    img_s : ass_img_tickets_b},
                    {name_s: 'Game Status',         id_n: 3,    img_s : ass_img_dices_b},
                    {name_s: 'Players Locations',   id_n: 4,    img_s : ass_img_gps_w},
                    {name_s: 'Team Status',         id_n: 5,    img_s : ass_img_info_b},
                    {name_s: 'Missions List',       id_n: 6,    img_s : ass_img_info_b},
                    {name_s: 'Quest Map',           id_n: 7,    img_s : ass_img_info_b},
                    {name_s: 'Team Chat',           id_n: 8,    img_s : ass_img_info_b},
                    {name_s: 'Point Table',         id_n: 9,    img_s : ass_img_info_b},
                    {name_s: 'Chart Map Missions',  id_n: 10,    img_s : ass_img_info_b},
                    {name_s: 'Chart List Missions', id_n: 11,    img_s : ass_img_info_b},
                    {name_s: 'Chart Points',        id_n: 11,    img_s : ass_img_info_b},
                ],
                showTab_byTabId_b : {},


                selectedTabIndex_vs                         : {val : 0},
                tqTabs_selectedTabIndex_chart_vl            : {val : 0},
                selectedObserveTeamsId_as                   : [],
                mapPlayersLocations_byTeamId_byUserId_c     : {},
                initObservableTeams_b                       : false,
                chatScrollToBottom_b                        : true,
                chatBottomNotification_n                    : 0,

                popup_show_savedMessage_vb                  : {val : false},

                missionsPoints_byTeamId_byType_byRiddleId_n : {},

                // ========== store =============
                store_questEvent                        : undefined,
                store_system_langCode_v                 : store_getStateValue_vo(store_var.system_langCode),
                store_system_windowSizeType_ve          : store_getStateValue_vo(store_var.system_windowSizeType_e),
                store_observableTeamsIds_byQuestId_vas  : store_getStateValue_vo(store_var.creator_events_item_observableTeamsIds_byQuestId_as),
                store_chat_msgShowTranslate_v_byMsgTime_b : store_getStateValue_vo(store_var.ongoing_chat_msgShowTranslate_byMsgTime_b),

                // ========= server ============
                server_questBody_c                      : undefined,
                server_messages_byTeamId_bySendTime_c   : {},
                server_questExplore_c                   : undefined,
                server_questEvent_c                     : undefined,
                server_creatorData_c                    : undefined,
                server_gameStatus_c                     : null,
                server_savedMessages_byTimestamp_c      : {},

                server_currentUserData_c                : undefined,
                server_subPlanInfo_c                : undefined,
                server_creatorMonthlyTickets_c                : undefined,

                server_teamsStatus_byTeamId_c                   : {},
                server_usersData_byUserId                       : {},
                server_playersMoreInfo_byUserId_c               : {},
                server_questTickets_ac                          : [],

                server_ts_mapMissions_byTeamId_byRiddleId_c         : {},
                server_ts_mapLastMissions_byTeamId_byRiddleId_c     : {},
                server_ts_listMissions_byTeamId_byRiddleId_c        : {},
                server_ts_cardsMissions_byTeamId_byRiddleId_c        : {},

                // ======= imports ===========
                enum_screenSizesOptions_n           : enum_screenSizesOptions_n,
                enum_subCollection_teamStatus       : enum_subCollection_teamStatus,
                ass_strings                         : ass_strings,
                ass_img_chat_w                      : ass_img_chat_w,
                ass_img_map_w                       : ass_img_map_w,
                ass_img_target_w                    : ass_img_target_w,
                ass_img_cards_w                     : ass_img_cards_w,
                ass_img_tickets_w                   : ass_img_tickets_w,
                ass_img_chart_w                     : ass_img_chart_w,
                ass_img_gps_w                       : ass_img_gps_w,
                ass_img_playersGroup_w              : ass_img_playersGroup_w,
                ass_img_dice_w                      : ass_img_dice_w,
                ass_img_info_w                      : ass_img_info_w,

                format_date_YYYY_MM_DD_hh_mm_fs                      : format_date_YYYY_MM_DD_hh_mm_fs,
                format_clockType_f                                  : format_clockType_f,

                serverOngoing_gameStatus_team_update_f  : serverOngoing_gameStatus_team_update_f,
                serverOngoing_teamStatus_and_gameStatus_update_f               : serverOngoing_teamStatus_update_f,
                serverOngoing_gameStatus_team_delete_f  : serverOngoing_gameStatus_team_delete_f,

                // event header
                server_questEvent_update_f                          : server_questEvent_update_f,
                server_questEvent_delete_f                          : server_questEvent_delete_f,

                // tickets
                route_openNewWindow_f                               : route_openNewWindow_f,

                // game status
                server_createNewTeam_f                              : serverOngoing_createNewTeam_f,
                server_updateGameStatus_timeExtensions_f            : serverOngoing_gameStatus_timeExtensions_update_f,
                server_updateGameStatus_creatorSetStartTime_f       : serverOngoing_gameStatus_creatorSetStartTime_update_f,

                // chat
                server_ongoingSavedMsg_set_f                        : serverOngoing_savedMsg_set_f,

            }
        },
        computed:{

            co_chartTabs_ao(){

                let ans_ao = [];

                ans_ao.push({name: ass_strings.oneWord_table, id: 0})


                if(this.server_questBody_c.qb_metadata_c.qbm_quest_supportMapMissions_b){
                    ans_ao.push({name: ass_strings.twoWords_mapMissions, id: 4})
                }
                if(this.server_questBody_c.qb_metadata_c.qbm_quest_supportCardsMissions_b){
                    ans_ao.push({name: ass_strings.twoWords_cardsMissions, id: 1})
                }

                if(this.server_questBody_c.qb_metadata_c.qbm_quest_supportListMissions_b){
                    ans_ao.push({name: ass_strings.twoWords_missionsList, id: 2})
                }
                if(this.server_questBody_c.qb_metadata_c.qbm_missions_supportMissionsPoints_b){
                    ans_ao.push({name: ass_strings.twoWords_missionsPoints, id: 3})
                }



                return ans_ao
            },
            co_currentTeamIndex_n(){

                if(this.co_selectedTeamId_uid == null){
                    return 0
                }

                return this.server_gameStatus_c.gs_teams_byTeamId[this.co_selectedTeamId_uid].gst_missionsArrangementIndex_n
            },

            co_tableColumns_fo(){

                let supportSkips_b = this.server_questBody_c.qb_metadata_c.qbm_missions_supportSkips_b
                let supportClues_b = this.server_questBody_c.qb_metadata_c.qbm_missions_supportClues_b
                let supportPoints_b = this.server_questBody_c.qb_metadata_c.qbm_missions_supportMissionsPoints_b
                let supportNetMissionTime_b = this.server_questBody_c.qb_metadata_c.qbm_missions_locksType_e === enum_missions_LocksType_s.start_time

                let supportCards_b = this.server_questBody_c.qb_metadata_c.qbm_quest_supportCardsMissions_b
                let supportListMissions_b = this.server_questBody_c.qb_metadata_c.qbm_quest_supportListMissions_b
                let supportMapMissions_b = this.server_questBody_c.qb_metadata_c.qbm_quest_supportMapMissions_b

                let ans_ao = [
                    // teamName
                    {label : ass_strings.twoWords_TeamName[this.store_system_langCode_v.val],
                        field : (teamId_uid) => {
                            if(this.server_gameStatus_c.gs_teams_byTeamId[teamId_uid] == null){
                                return ""
                            }
                            return this.server_gameStatus_c.gs_teams_byTeamId[teamId_uid].gst_name_s }
                    },


                    // total points
                    supportPoints_b &&
                        {label : ass_strings.oneWord_points[this.store_system_langCode_v.val],      field : (teamId_uid) => {
                                if(this.server_gameStatus_c.gs_teams_byTeamId[teamId_uid] == null){
                                    return ""
                                }
                            return this.server_gameStatus_c.gs_teams_byTeamId[teamId_uid].gst_m_totalPoints_n()
                        }},

                    // total points
                    supportNetMissionTime_b &&
                        {label : ass_strings.twoWords_netTime[this.store_system_langCode_v.val],      field : (teamId_uid) => {
                                if(this.server_gameStatus_c.gs_teams_byTeamId[teamId_uid] == null){
                                    return "-"
                                }
                                return format_duration_hhmmss(this.server_gameStatus_c.gs_teams_byTeamId[teamId_uid].gst_m_netTimeMillScn_fn())
                            }},

                    // totalTime
                    {label : ass_strings.twoWords_totalTime2[this.store_system_langCode_v.val],     field : (teamId_uid) => {
                        return helper_getFinishDuration_fs({questEvent_c:this.server_questEvent_c, gameStatus_c: this.server_gameStatus_c, teamId_uid: teamId_uid, clockStartClock_e : this.store_questEvent.qev_startClockType_e})
                    }},
                ]

                return ans_ao.filter(item => {return item !== false})

            },
            co_listMissions_byRiddleId_c(){

                let ans_byRiddleId_c = {}

                if(this.server_questBody_c == null){
                    return ans_byRiddleId_c
                }

                this.server_questBody_c.qb_listMissions_ac.forEach(qb_riddle_c => {
                    ans_byRiddleId_c[qb_riddle_c.qbr_riddleId_n] = qb_riddle_c
                })

                return ans_byRiddleId_c
            },
            co_cardsMissions_byRiddleId_c(){

                let ans_byRiddleId_c = {}

                if(this.server_questBody_c == null){
                    return ans_byRiddleId_c
                }

                this.server_questBody_c.qb_cardsMissions_ac.forEach(qb_riddle_c => {
                    ans_byRiddleId_c[qb_riddle_c.qbr_riddleId_n] = qb_riddle_c
                })


                return ans_byRiddleId_c
            },
            co_startingTime_byTimeId_t(){
                let ans_byTeamId_t = {}


                obj_forEach_f(this.server_gameStatus_c.gs_teams_byTeamId, gs_team_c =>{

                    switch(this.store_questEvent.qev_startClockType_e){
                        case enum_questEventStartClockTypes_s.eventStartClock:
                            ans_byTeamId_t[gs_team_c.gst_teamId_uid] = this.server_questEvent_c.qev_startingDate_t
                            break;

                        case enum_questEventStartClockTypes_s.creatorStartClock:
                            ans_byTeamId_t[gs_team_c.gst_teamId_uid] =  this.server_gameStatus_c.gs_creatorStartTime_t
                            break;

                        case enum_questEventStartClockTypes_s.playerStartClock:

                            if(this.server_gameStatus_c != null && this.server_gameStatus_c.gs_teams_byTeamId[gs_team_c.gst_teamId_uid] != null) {
                                ans_byTeamId_t[gs_team_c.gst_teamId_uid] = this.server_gameStatus_c.gs_teams_byTeamId[gs_team_c.gst_teamId_uid].gst_playerStartTime_t
                            }
                            break;
                    }
                })
                return ans_byTeamId_t
            },

            // missionChart
            co_missionChart_datasets(){

                let ans = []

                this.selectedObserveTeamsId_as.forEach((teamId_uid) => {

                    if(this.server_teamsStatus_byTeamId_c[teamId_uid] == null || this.server_gameStatus_c.gs_teams_byTeamId[teamId_uid] == null){return;}

                    ans.push({
                        label           : this.server_gameStatus_c.gs_teams_byTeamId[teamId_uid].gst_name_s,
                        backgroundColor : this.server_gameStatus_c.gs_teams_byTeamId[teamId_uid].gst_color_s,
                        data            : [this.server_gameStatus_c.gs_teams_byTeamId[teamId_uid].gst_m_totalPoints_n()]
                    })
                })

                return ans
            },
            co_missionChart_labels(){

                return ['Missions']
            },

            // === teams ===
            co_getPlayersIds_byUserId_c(){

                if(!this.server_gameStatus_c || !this.co_selectedTeamId_uid){
                    return {}
                }

                return this.server_gameStatus_c.gs_teams_byTeamId[this.co_selectedTeamId_uid].gst_players_byUserId_c
            },
            co_getFinishMapMissionsIndexes_an(){

                if(this.co_teamsTabs_ac[this.selectedTabIndex_vs.val] == null || this.server_questBody_c == null){
                    return []
                }

                let teamId = this.co_teamsTabs_ac[this.selectedTabIndex_vs.val].gst_teamId_uid

                if(this.server_ts_mapMissions_byTeamId_byRiddleId_c[teamId] == null){
                    return []
                }

                let ans = [];
                for(let i =0; i < this.server_questBody_c.qb_mapMissions_ac.length; i++){

                    let qb_riddleId_n = this.server_questBody_c.qb_mapMissions_ac[i].qbr_riddleId_n
                    if(helper_finishRiddle_fb(this.server_questBody_c.qb_mapMissions_ac[i], this.server_ts_mapMissions_byTeamId_byRiddleId_c[teamId][qb_riddleId_n])){
                        ans.push(i)
                    }
                }

                return ans

            },
            co_allObserveTeamsPlayersLocations_byUserId_c(){
                let ans ={}
                this.selectedObserveTeamsId_as.forEach(teamId_uid => {
                    Object.assign(ans, this.mapPlayersLocations_byTeamId_byUserId_c[teamId_uid])
                })

                return ans
            },

            // ==== teams tabs ====
            co_gs_teams_byTeamsIdC(){

                let ans = {}
                for(let teamId_uid in this.server_gameStatus_c.gs_teams_byTeamId){
                    if(this.selectedObserveTeamsId_as.includes(teamId_uid)){
                        ans[teamId_uid] = this.server_gameStatus_c.gs_teams_byTeamId[teamId_uid]
                    }
                }

                return ans
            },
            co_allTeamsIds_as(){

                if(this.server_gameStatus_c.gs_teams_byTeamId == null){
                    return []
                }

                return Object.keys(this.server_gameStatus_c.gs_teams_byTeamId)
            },
            co_selectedTeamId_uid(){
                if(this.co_teamsTabs_ac[this.selectedTabIndex_vs.val] == null)
                    return null

                return this.co_teamsTabs_ac[this.selectedTabIndex_vs.val].gst_teamId_uid
            },
            co_teamsTabs_ac(){

                if(this.server_gameStatus_c == null){
                    return []
                }

                let ans = []
                for(let teamId_uid in this.server_gameStatus_c.gs_teams_byTeamId){
                    if(this.selectedObserveTeamsId_as.includes(teamId_uid)){
                        ans.unshift(this.server_gameStatus_c.gs_teams_byTeamId[teamId_uid])
                    }
                }

                return ans;
            },
            co_displayLangCode_e(){
                return this.server_questBody_c.cm_qb_getDisplayLangCode_e(this.store_system_langCode_v.val)
            },

            // ==== teams tabs notification ====
            co_chatNotification_byTabsIndex_n() {
                let ans = {}

                let userId_uid = this.server_currentUserData_c.ud_userId_uid


                for (let teamId_uid in this.server_messages_byTeamId_bySendTime_c) {

                    let numOfUnReadMsg_n = 0;

                    for (let sendTime in this.server_messages_byTeamId_bySendTime_c[teamId_uid]) {
                        let msg = new FB_Message(this.server_messages_byTeamId_bySendTime_c[teamId_uid][sendTime]);

                        if (msg.ms_readMsg_byUserId_b[userId_uid] || teamId_uid === this.co_selectedTeamId_uid){
                            continue
                        }

                        numOfUnReadMsg_n++;
                    }

                    let tabIndex_n = helper_getObjIndexInArray_fn(this.co_teamsTabs_ac, 'gst_teamId_uid', teamId_uid)
                    ans[tabIndex_n] = numOfUnReadMsg_n
                }
                return ans

            },
            co_mapNotification_byTabsIndex_n(){
                let ans = {}

                for(let teamId_uid in this.server_gameStatus_c.gs_teams_byTeamId){

                    let tabIndex_n = helper_getObjIndexInArray_fn(this.co_teamsTabs_ac, 'gst_teamId_uid', teamId_uid)
                    ans[tabIndex_n] = 0

                    let ts_riddles_byRiddleId_c = this.server_ts_mapMissions_byTeamId_byRiddleId_c[teamId_uid]
                    for(let riddleId_n in ts_riddles_byRiddleId_c) {

                        let ts_riddle = ts_riddles_byRiddleId_c[riddleId_n]

                        let qb_missionRiddle_index = helper_getObjIndexInArray_fn(this.server_questBody_c.qb_mapMissions_ac, 'qbr_riddleId_n', parseInt(riddleId_n))
                        if(qb_missionRiddle_index < 0 ) {continue}

                        for(let unlockId_n in ts_riddle.rs_unlock_byLockId_c) {
                            let rs_unlockData = ts_riddle.rs_unlock_byLockId_c[unlockId_n]

                            let qb_mapMission_c = this.server_questBody_c.qb_mapMissions_ac[qb_missionRiddle_index]

                            if(qb_mapMission_c.qbr_locks_ac[unlockId_n] == null){
                                continue
                            }

                            let lockType = qb_mapMission_c.qbr_locks_ac[unlockId_n].qbrl_type_e

                            if ([enum_lockTypes.VIDEO, enum_lockTypes.IMAGE].includes(lockType)
                                && rs_unlockData.rsud_lockState_e === enum_lockState.waitingToApprove
                                && !helper_finishRiddle_fb(qb_mapMission_c, ts_riddle)) {
                                ans[tabIndex_n]++
                            }
                        }
                    }
                }

                return ans
            },
            co_missionsNotification_byTabsIndex_n(){
                let ans = {}

                for(let teamId_uid in this.server_gameStatus_c.gs_teams_byTeamId){

                    let tabIndex_n = helper_getObjIndexInArray_fn(this.co_teamsTabs_ac, 'gst_teamId_uid', teamId_uid)
                    ans[tabIndex_n] = 0;

                    let teamStatusMissionsRiddles_byRiddleId_c = this.server_ts_listMissions_byTeamId_byRiddleId_c[teamId_uid]
                    for(let riddleId_n in teamStatusMissionsRiddles_byRiddleId_c) {

                        let riddleStatus_mission = teamStatusMissionsRiddles_byRiddleId_c[riddleId_n]

                        let qb_missionRiddle_index = helper_getObjIndexInArray_fn(this.server_questBody_c.qb_listMissions_ac, 'qbr_riddleId_n', parseInt(riddleId_n))

                        if(qb_missionRiddle_index < 0 ) {continue}

                        for(let unlockId_n in riddleStatus_mission.rs_unlock_byLockId_c) {
                            let rs_unlockData = riddleStatus_mission.rs_unlock_byLockId_c[unlockId_n]

                            if(this.server_questBody_c.qb_listMissions_ac[qb_missionRiddle_index].qbr_locks_ac[unlockId_n] == null){continue}

                            let lockType = this.server_questBody_c.qb_listMissions_ac[qb_missionRiddle_index].qbr_locks_ac[unlockId_n].qbrl_type_e

                            if ([enum_lockTypes.VIDEO, enum_lockTypes.IMAGE].includes(lockType)
                                && rs_unlockData.rsud_lockState_e === enum_lockState.waitingToApprove
                                && rs_unlockData.rsud_skip_b === false) {
                                ans[tabIndex_n]++
                            }
                        }
                    }
                }

                return ans
            },
            co_mapLastMissionsNotification_byTabsIndex_n(){
                let ans = {}

                if(this.server_questBody_c == null || !this.server_questBody_c.qb_metadata_c.qbm_quest_supportMapLastMissions_b){
                    return ans
                }

                for(let teamId_uid in this.server_gameStatus_c.gs_teams_byTeamId){

                    let tabIndex_n = helper_getObjIndexInArray_fn(this.co_teamsTabs_ac, 'gst_teamId_uid', teamId_uid)
                    ans[tabIndex_n] = 0;

                    let teamStatusMissionsRiddles_byRiddleId_c = this.server_ts_mapLastMissions_byTeamId_byRiddleId_c[teamId_uid]
                    for(let riddleId_n in teamStatusMissionsRiddles_byRiddleId_c) {

                        let riddleStatus_mission = teamStatusMissionsRiddles_byRiddleId_c[riddleId_n]

                        let qb_missionRiddle_index = helper_getObjIndexInArray_fn(this.server_questBody_c.qb_mapLastMissions_ac, 'qbr_riddleId_n', parseInt(riddleId_n))

                        if(qb_missionRiddle_index < 0 ) {continue}

                        for(let unlockId_n in riddleStatus_mission.rs_unlock_byLockId_c) {
                            let rs_unlockData = riddleStatus_mission.rs_unlock_byLockId_c[unlockId_n]

                            if(this.server_questBody_c.qb_mapLastMissions_ac[qb_missionRiddle_index].qbr_locks_ac[unlockId_n] == null){continue}

                            let lockType = this.server_questBody_c.qb_mapLastMissions_ac[qb_missionRiddle_index].qbr_locks_ac[unlockId_n].qbrl_type_e

                            if ([enum_lockTypes.VIDEO, enum_lockTypes.IMAGE].includes(lockType)
                                && rs_unlockData.rsud_lockState_e === enum_lockState.waitingToApprove
                                && rs_unlockData.rsud_skip_b === false) {
                                ans[tabIndex_n]++
                            }
                        }
                    }
                }

                return ans
            },

        },
        methods:{

            // user events
            m_userEvent_updateCardsMission_LockStatus(riddleId_n, lockIndex_n, lock_c, lockStatus_e, cb_f){

                serverOngoing_teamStatusSub_rsud_status_update_f({
                    questEvent_c                : this.store_questEvent,
                    teamId_uid                  : this.co_selectedTeamId_uid,
                    riddleId_n                  : riddleId_n,
                    qbr_locks_c               : lock_c,
                    lockId_n                    : lockIndex_n,
                    teamStatus_subCollection_e  : enum_subCollection_teamStatus.CARDS_MISSIONS,
                    lockStatus_e                : lockStatus_e,
                    cb_f                        : cb_f
                })

            },
            m_userEvent_updateMapMission_LockStatus(riddleId_n, lockIndex_n, lock_c, lockStatus_e, cb_f){

                serverOngoing_teamStatusSub_rsud_status_update_f({
                    questEvent_c                : this.store_questEvent,
                    teamId_uid                  : this.co_selectedTeamId_uid,
                    riddleId_n                  : riddleId_n,
                    qbr_locks_c               : lock_c,
                    lockId_n                    : lockIndex_n,
                    teamStatus_subCollection_e  : enum_subCollection_teamStatus.MAP_MISSIONS,
                    lockStatus_e                : lockStatus_e,
                    cb_f                        : cb_f
                })

            },
            m_userEvent_updateMapLastMission_LockStatus(riddleId_n, lockIndex_n, lock_c, lockStatus_e, cb_f){

                serverOngoing_teamStatusSub_rsud_status_update_f({
                    questEvent_c                : this.store_questEvent,
                    teamId_uid                  : this.co_selectedTeamId_uid,
                    riddleId_n                  : riddleId_n,
                    qbr_locks_c               : lock_c,
                    lockId_n                    : lockIndex_n,
                    teamStatus_subCollection_e  : enum_subCollection_teamStatus.MAP_LAST_MISSIONS,
                    lockStatus_e                : lockStatus_e,
                    cb_f                        : cb_f,
                    updateFinishTime_fb         : () => {

                        let riddleIndex_c = helper_getRiddleIndexWithRiddleId_fn(this.server_questBody_c.qb_mapLastMissions_ac, riddleId_n)
                        let riddle_c = this.server_questBody_c.qb_mapLastMissions_ac[riddleIndex_c]

                        let finishRiddle_b = helper_finishRiddle_fb(riddle_c, this.server_ts_mapLastMissions_byTeamId_byRiddleId_c[this.co_selectedTeamId_uid][riddleId_n])
                        let lastRiddle_b = riddleIndex_c === this.server_questBody_c.qb_mapLastMissions_ac.length - 1

                        return finishRiddle_b && lastRiddle_b
                    },
                })

            },
            m_userEvent_updateListMissions_LockStatus(riddleId_n, lockIndex_n, lock_c, lockStatus_e, cb_f){
                serverOngoing_teamStatusSub_rsud_status_update_f({
                    questEvent_c                : this.store_questEvent,
                    teamId_uid                  : this.co_selectedTeamId_uid,
                    riddleId_n                  : riddleId_n,
                    qbr_locks_c               : lock_c,
                    lockId_n                    : lockIndex_n,
                    teamStatus_subCollection_e  : enum_subCollection_teamStatus.LIST_MISSIONS,
                    lockStatus_e                : lockStatus_e,
                    cb_f                        : cb_f
                })
            },
            m_sendTeamsMedia_f(){

                if(this.selectedObserveTeamsId_as.length === 0 ){
                    notification_notify2({title_s: ass_strings.oneWord_error[this.store_system_langCode_v.val], text_s: ass_strings.threeWords_pleaseSelectTeams[this.store_system_langCode_v.val]})
                    return
                }

                let sendMailText_s = ''
                if(this.server_questBody_c.qb_metadata_c.qbm_quest_supportListMissions_b){
                    sendMailText_s += this.m_sendTeamsMedia_getEmailHtml_fs(this.server_questBody_c.qb_listMissions_ac, this.server_ts_listMissions_byTeamId_byRiddleId_c)
                }
                if(this.server_questBody_c.qb_metadata_c.qbm_quest_supportCardsMissions_b){
                    sendMailText_s += this.m_sendTeamsMedia_getEmailHtml_fs(this.server_questBody_c.qb_cardsMissions_ac, this.server_ts_cardsMissions_byTeamId_byRiddleId_c)
                }
                if(this.server_questBody_c.qb_metadata_c.qbm_quest_supportMapMissions_b){
                    sendMailText_s += this.m_sendTeamsMedia_getEmailHtml_fs(this.server_questBody_c.qb_mapMissions_ac, this.server_ts_mapMissions_byTeamId_byRiddleId_c)
                }

                if(sendMailText_s === ''){
                    return
                }

                let sendEmail_c = new FB_SendEmail({
                    se_sendToEmail_s: this.server_creatorData_c.ud_email_s,
                    se_title_s      : `${this.server_questEvent_c.qev_name_byLangCode_s[this.co_displayLangCode_e]} - ${format_date_YYYY_MM_DD_hh_mm_fs(this.server_questEvent_c.qev_startingDate_t)}`,
                    se_message_s    : sendMailText_s,
                })

                server_sendMail_fp(sendEmail_c).then( () => {
                    notification_notify2({title_s: ass_strings.twoWords_sentEmail[this.store_system_langCode_v.val] })
                })


            },
            m_sendTeamsMedia_getEmailHtml_fs(questMissions_ac, ts_questMissions_byTeamId_byRiddleId_c){
                return `
                <div style="overflow-y: auto; width: 100%;">
                    <table style="  border-collapse: collapse;">
                        <tr style="border:1px solid black; font-size: 20px">
                            ${obj_vFor_f(this.selectedObserveTeamsId_as, (teamId_uid) => {
                    return`
                                <td style="border:1px solid black; padding: 4px; background: #EAE6E1 ">
                                     ${this.server_gameStatus_c.gs_teams_byTeamId[teamId_uid].gst_name_s}
                                </td>`
                })}
                        </tr>

                        ${obj_vFor_f(questMissions_ac, qb_riddle_c => {

                    return obj_vFor_f(qb_riddle_c.qbr_locks_ac, (qbr_lock_c, lockIndex_n) => {
                        switch (qbr_lock_c.qbrl_type_e) {
                            case enum_lockTypes.VIDEO:
                            case enum_lockTypes.IMAGE:
                                return `
                                            <tr style="border:1px solid black">
                                                ${obj_vFor_f(this.selectedObserveTeamsId_as, teamId_uid => {
                                    let ts_riddles_byRiddleId_c = ts_questMissions_byTeamId_byRiddleId_c[teamId_uid]
                                    let ts_riddle_c = ts_riddles_byRiddleId_c[qb_riddle_c.qbr_riddleId_n]

                                    if(ts_riddle_c && ts_riddle_c.rs_unlock_byLockId_c && ts_riddle_c.rs_unlock_byLockId_c[lockIndex_n] && ts_riddle_c.rs_unlock_byLockId_c[lockIndex_n].rsud_imgFile_c){

                                        let file_c = ts_riddle_c.rs_unlock_byLockId_c[lockIndex_n].rsud_imgFile_c
                                        return `
                                                        <td style="border:1px solid black; padding: 4px; background: #EAE6E1 ">
                                                            <a href="${file_c.fi_url_s}" target="_blank"> ${qb_riddle_c.qbr_title_blc_s[this.co_displayLangCode_e]} <br> ${qbr_lock_c.qbrl_title_blc_s[this.co_displayLangCode_e]} </a>
                                                         </td>`
                                    }else{
                                        return `
                                                        <td style="border:1px solid black; padding: 4px; background: #EAE6E1 ">
                                                            -
                                                        </td>`
                                    }
                                })}

                                            </tr>
                                            `
                            default:
                                return ""
                        }
                    })
                })}



                    </table>
                </div>
                `
            },

            // headquarters
            m_chat_updateReadMassages_selectedTeam_f(){

                if(this.co_selectedTeamId_uid == null){return}

                let userId = this.server_currentUserData_c.ud_userId_uid
                let chatMessages_bySendTime_c = this.server_messages_byTeamId_bySendTime_c[this.co_selectedTeamId_uid]

                for(let sendTime in chatMessages_bySendTime_c){
                    let msg = new FB_Message(chatMessages_bySendTime_c[sendTime]);

                    if(msg.ms_readMsg_byUserId_b[userId])
                        continue

                    serverOngoing_chatMessage_read_f(this, this.store_questEvent, this.co_selectedTeamId_uid, msg, userId)

                }
            },
            m_chat_sendMsg_f(msg_c){
                serverOngoing_chatMessage_send_f(this.store_questEvent, this.co_selectedTeamId_uid, msg_c, () => {})

                date_setTimeout(() =>{
                    this.m_chat_scrollDown_f()
                },100, this.$options.name)
            },
            m_chat_sendMsgToAll(msg_c){
                for(let teamId_uid in this.server_gameStatus_c.gs_teams_byTeamId) {
                    serverOngoing_chatMessage_send_f(this.store_questEvent, teamId_uid, msg_c, () => {})
                }
                date_setTimeout(() =>{
                    this.m_chat_scrollDown_f()
                },100, this.$options.name)
            },
            m_chat_scrollDown_f(){

                let div = this.$refs.ref_chatMessages
                div.scrollTop = div.scrollHeight;

            },
            m_chat_setScrollingListener(){

                eventListener_addEventListenerToObj(this.$refs.ref_chatMessages, enum_eventsListenersNames.scroll, false, this.$options.name, () => {
                    this.m_chat_doOnScrollChange_f()
                })

                date_setTimeout(() => {
                    this.m_chat_scrollDown_f()
                },5, this.$options.name)

            },
            m_chat_doOnScrollChange_f(){

                let chatDiv_o = this.$refs.ref_chatMessages

                this.chatScrollToBottom_b = chatDiv_o.scrollTop >=
                    (chatDiv_o.scrollHeight - chatDiv_o.offsetHeight - gv_numbers.chatSaveDistance)

                if(this.chatScrollToBottom_b){
                    this.chatBottomNotification_n = 0
                }
            },
            async m_chat_translate_f(msg_c){

                // update store
                this.$set(this.store_chat_msgShowTranslate_v_byMsgTime_b.val, msg_c.ms_sendTime_n, true)
                store_setStateValue(store_var.ongoing_chat_msgShowTranslate_byMsgTime_b, this.store_chat_msgShowTranslate_v_byMsgTime_b.val)

                // if dont have translate
                if(msg_c.ms_translate_blc_s[this.store_system_langCode_v.val] == null){
                    this.$set(msg_c.ms_translate_blc_s, this.store_system_langCode_v.val, ass_strings.oneWord_loading[this.store_system_langCode_v.val] + "...")

                    await serverOngoing_chatMessage_translate_f(this.server_questEvent_c, this.co_selectedTeamId_uid, msg_c, this.store_system_langCode_v.val, () => {})
                }
            },

            // observable
            m_initLastCachedObservableTeams_f(){

                if(this.server_questBody_c == null || this.server_currentUserData_c == null || this.server_gameStatus_c == null || this.initObservableTeams_b){
                    return
                }

                this.initObservableTeams_b = true

                let lastSelectedObservableTeamsIds_as = this.store_observableTeamsIds_byQuestId_vas.val[this.store_questEvent.qev_questId_uid]
                if(lastSelectedObservableTeamsIds_as != null){
                    lastSelectedObservableTeamsIds_as.forEach(teamId_uid => {
                        this.m_toggleObserveTeam_f(teamId_uid)
                    })
                }
            },
            m_toggleObserveTeam_f(teamId_uid){

                let index = this.selectedObserveTeamsId_as.indexOf(teamId_uid)
                if(index >= 0 ){
                    this.selectedObserveTeamsId_as.splice(index,1)
                    this.m_removeListenersTeam_f(teamId_uid)
                }else if(this.server_gameStatus_c.gs_teams_byTeamId[teamId_uid] != null){
                    this.selectedObserveTeamsId_as.push(teamId_uid)
                    this.m_setListenersTeam_f(teamId_uid)
                }

                // set store
                this.store_observableTeamsIds_byQuestId_vas.val[this.store_questEvent.qev_questId_uid] = this.selectedObserveTeamsId_as
                store_setStateValue(store_var.creator_events_item_observableTeamsIds_byQuestId_as, this.store_observableTeamsIds_byQuestId_vas.val)


            },

            // listeners
            m_setListenersTeam_f(teamId_uid){


                if(this.server_gameStatus_c.gs_teams_byTeamId[teamId_uid] == null){return}

                // check if set listener
                if(this.server_messages_byTeamId_bySendTime_c[teamId_uid] != null) {return}

                // 1) chat
                this.$set(this.server_messages_byTeamId_bySendTime_c, teamId_uid,{})
                serverOngoing_chatMessages_cl_set_f(this.$options.name, this.server_currentUserData_c.ud_userId_uid ,this.store_questEvent, teamId_uid,
                    msg_c => {

                        if(msg_c.ms_receiveMsg_byUserId_b[this.server_currentUserData_c.ud_userId_uid] == null){

                            file_playAudio_f(this.server_questBody_c.qb_metadata_c.qbm_audio_chatUrl_s);
                            serverOngoing_chatMessage_receive_f(this.store_questEvent, teamId_uid, msg_c, this.server_currentUserData_c.ud_userId_uid)

                            // update chat bottom notification
                            if(teamId_uid === this.co_selectedTeamId_uid){
                                this.chatBottomNotification_n++

                                date_setTimeout(() => {
                                    this.m_chat_doOnScrollChange_f()
                                },5, this.$options.name)
                            }
                        }

                        this.$set(this.server_messages_byTeamId_bySendTime_c[teamId_uid], msg_c.ms_sendTime_n, msg_c)

                        if(teamId_uid === this.co_selectedTeamId_uid){
                            this.m_chat_updateReadMassages_selectedTeam_f()
                        }
                    })

                // 2) team status
                let firstCall_b = true
                this.$set(this.server_ts_mapMissions_byTeamId_byRiddleId_c,         teamId_uid, {})
                this.$set(this.server_ts_mapLastMissions_byTeamId_byRiddleId_c,     teamId_uid, {})
                this.$set(this.server_ts_listMissions_byTeamId_byRiddleId_c,        teamId_uid, {})
                this.$set(this.server_ts_cardsMissions_byTeamId_byRiddleId_c,       teamId_uid, {})
                serverOngoing_teamStatus_vl_set_f({
                    viewName_s: this.$options.name, 
                    questEvent_c : this.store_questEvent, 
                    teamId_uid,
                    cb_f: (teamStatus_c) => {
                        this.$set(this.server_teamsStatus_byTeamId_c, teamId_uid, teamStatus_c)

                        if(!firstCall_b || teamStatus_c == null){return}
                        firstCall_b = false

                        // 4.2.1) get team status subCollection
                        obj_forEach_f(enum_subCollection_teamStatus,
                            (subCollection_e) => {
                                serverOngoing_teamStatus_subCollection_cl_get_f({
                                    viewName_s          : this.$options.name,
                                    subCollectionName_e : subCollection_e,
                                    questEvent_c        : this.store_questEvent,
                                    teamId_uid          : teamId_uid,
                                    cb_ChildAdded_f     : (riddleStatus_c) => {


                                        switch(subCollection_e){

                                            // 1) MAP MISSIONS
                                            case enum_subCollection_teamStatus.MAP_MISSIONS:

                                                this.m_handleTeamStatusSubCollectionCb_f({
                                                    riddleStatus_c          : riddleStatus_c,
                                                    mission_ac              : this.server_questBody_c.qb_mapMissions_ac,
                                                    finishSound_r           : this.server_questBody_c.qb_metadata_c.qbm_audio_mapMissionsUrl_s,
                                                    notificationSound_r     : null,
                                                    teamId_uid              : teamId_uid,
                                                    subCollection           : enum_subCollection_teamStatus.MAP_MISSIONS
                                                })

                                                this.$set(this.server_ts_mapMissions_byTeamId_byRiddleId_c[teamId_uid], riddleStatus_c.rs_riddleId_n, riddleStatus_c)


                                                break;

                                            // 2) MAP last riddles
                                            case enum_subCollection_teamStatus.MAP_LAST_MISSIONS:

                                                this.m_handleTeamStatusSubCollectionCb_f({
                                                    riddleStatus_c          : riddleStatus_c,
                                                    mission_ac              : this.server_questBody_c.qb_mapLastMissions_ac,
                                                    finishSound_r           : this.server_questBody_c.qb_metadata_c.qbm_audio_lastMissionsUrl_s,
                                                    notificationSound_r     : null,
                                                    teamId_uid              : teamId_uid,
                                                    subCollection           : enum_subCollection_teamStatus.MAP_LAST_MISSIONS

                                                })

                                                this.$set(this.server_ts_mapLastMissions_byTeamId_byRiddleId_c[teamId_uid], riddleStatus_c.rs_riddleId_n, riddleStatus_c)


                                                break;

                                            // 3) CARDS MISSIONS
                                            case enum_subCollection_teamStatus.CARDS_MISSIONS:

                                                this.m_handleTeamStatusSubCollectionCb_f({
                                                    riddleStatus_c          : riddleStatus_c,
                                                    mission_ac              : this.server_questBody_c.qb_cardsMissions_ac,
                                                    finishSound_r           : this.server_questBody_c.qb_metadata_c.qbm_audio_cardsMissionsUrl_s,
                                                    notificationSound_r     : ass_audio_notifyMissions,
                                                    teamId_uid              : teamId_uid,
                                                    subCollection           : enum_subCollection_teamStatus.CARDS_MISSIONS
                                                })

                                                this.$refs.ref_cardsMissions.mRef_updateRiddleStatus_f(enum_subCollection_teamStatus.CARDS_MISSIONS, teamId_uid, riddleStatus_c)

                                                this.$set(this.server_ts_cardsMissions_byTeamId_byRiddleId_c[teamId_uid], riddleStatus_c.rs_riddleId_n, riddleStatus_c)

                                                break;
                                            

                                            // 5) MISSIONS RIDDLES
                                            case enum_subCollection_teamStatus.LIST_MISSIONS:

                                                this.m_handleTeamStatusSubCollectionCb_f({
                                                    riddleStatus_c          : riddleStatus_c,
                                                    mission_ac              : this.server_questBody_c.qb_listMissions_ac,
                                                    finishSound_r           : this.server_questBody_c.qb_metadata_c.qbm_audio_listMissionsUrl_s,
                                                    notificationSound_r     : ass_audio_notifyMissions,
                                                    teamId_uid              : teamId_uid,
                                                    subCollection           : enum_subCollection_teamStatus.LIST_MISSIONS
                                                })

                                                this.$set(this.server_ts_listMissions_byTeamId_byRiddleId_c[teamId_uid], riddleStatus_c.rs_riddleId_n, riddleStatus_c)

                                                break;
                                        }
                                    },
                                })
                            })
                    }     
                })

                // 3) get team players locations
                serverOngoing_teamPlayersGeoLocation_cl_set_f(this.$options.name, this.store_questEvent, teamId_uid,
                    (userGeoLocation_c) => {

                        // save mapPlayerLocation byTeamId
                        if(this.server_usersData_byUserId[userGeoLocation_c.ugl_userId_uid]){

                            if(this.mapPlayersLocations_byTeamId_byUserId_c[teamId_uid] == null){
                                this.$set(this.mapPlayersLocations_byTeamId_byUserId_c, teamId_uid, {})
                            }

                            this.$set(this.mapPlayersLocations_byTeamId_byUserId_c[teamId_uid], userGeoLocation_c.ugl_userId_uid, new FB_MapPlayerLocation({
                                mpl_userId_uid      : userGeoLocation_c.ugl_userId_uid,
                                mpl_username_s      : this.server_usersData_byUserId[userGeoLocation_c.ugl_userId_uid].ud_name_s,
                                mpl_dotColor_s      : this.server_gameStatus_c.gs_teams_byTeamId[teamId_uid].gst_color_s,
                                mpl_accuracy_n      : userGeoLocation_c.ugl_accuracy_n,
                                mpl_latitude_n      : userGeoLocation_c.ugl_latitude_n,
                                mpl_longitude_n     : userGeoLocation_c.ugl_longitude_n,
                                mpl_timestamp_t     : userGeoLocation_c.ugl_timestamp_t,
                                mpl_secondsForOld_n : 20,
                            }))
                        }
                    })
            },
            m_removeListenersTeam_f(teamId_uid){

                this.$set(this.server_messages_byTeamId_bySendTime_c, teamId_uid, null)

                // 1) remove team chatMessages
                serverOngoing_chatMessages_cl_remove(this.$options.name, this.store_questEvent, teamId_uid)

                // 2) remove team status
                serverOngoing_teamStatus_vl_remove_f(this.$options.name, this.server_questEvent_c, teamId_uid);

                // 3) remove team status subCollection
                obj_forEach_f(
                    enum_subCollection_teamStatus,
                    (subCollection_e) => {
                        serverOngoing_teamStatus_subCollection_cl_remove_f({
                            viewName_s          : this.$options.name,
                            subCollectionName_e : subCollection_e,
                            questEvent_c        : this.store_questEvent,
                            teamId_uid          : teamId_uid,
                        })
                    })

                // 4) remove players geo location
                serverOngoing_teamPlayersGeoLocation_cl_remove_f(this.$options.name, this.store_questEvent, teamId_uid)
            },

            // ===== helpers ====

            // m_handleTeamStatusSubCollectionCb_f
            m_handleTeamStatusSubCollectionCb_f({riddleStatus_c, mission_ac, finishSound_r, notificationSound_r, teamId_uid, subCollection}){

                let qb_riddle_c = helper_getRiddleWithRiddleId_fc(mission_ac, riddleStatus_c.rs_riddleId_n)
                if(qb_riddle_c == null){
                    return
                }
                let riddleStatusLastActionTimestamp_t = riddleStatus_c.cm_rs_lastUpdateTimestamp_t()

                // 1) team sum total points
                if(this.selectedObserveTeamsId_as.includes(teamId_uid) && this.server_questBody_c.qb_metadata_c.qbm_missions_supportMissionsPoints_b){

                    // update point chart
                    if(this.missionsPoints_byTeamId_byType_byRiddleId_n[teamId_uid] == null){
                        this.missionsPoints_byTeamId_byType_byRiddleId_n[teamId_uid] = {}
                        obj_forEach_f(enum_subCollection_teamStatus, (subCollection2_e) => {this.missionsPoints_byTeamId_byType_byRiddleId_n[teamId_uid][subCollection2_e] = {}})
                    }

                    this.missionsPoints_byTeamId_byType_byRiddleId_n[teamId_uid][subCollection][qb_riddle_c.qbr_riddleId_n] = riddleStatus_c.cm_rs_locksTotalPoints_n()

                }

                // 2) play audio
                if( this.selectedObserveTeamsId_as.includes(teamId_uid)
                    && date_getTimePastInSeconds_fn(riddleStatusLastActionTimestamp_t) < 150){

                    if(helper_finishRiddle_fb(qb_riddle_c, riddleStatus_c)){
                        file_playAudio_f(finishSound_r)

                    }else if(notificationSound_r){
                        // for each lock
                        for(let lockIndex_n in riddleStatus_c.rs_unlock_byLockId_c){

                            let rs_unlockData_c = riddleStatus_c.rs_unlock_byLockId_c[lockIndex_n]
                            let lock_c = qb_riddle_c.qbr_locks_ac[lockIndex_n]

                            // check if file lock and status = waiting to approve
                            if( [enum_lockTypes.IMAGE, enum_lockTypes.VIDEO].includes(lock_c.qbrl_type_e) &&
                                rs_unlockData_c.rsud_lockState_e === enum_lockState.waitingToApprove){

                                file_playAudio_f(notificationSound_r)
                                break;
                            }
                        }
                    }
                }
            },
        },
        watch:{
            "selectedTabIndex_vs.val" : {
                handler(){
                    this.m_chat_updateReadMassages_selectedTeam_f();
                },

            },
        },

        // ====== life circle =======
        activated(){


            if(!obj_equals_fb(this.$data, this.$options.data.apply(this))){
                obj_deepCopy_f2(this.$data, this.$options.data.call(this))
            }

            this.store_questEvent = store_getStateValue_vo(store_var.creator_events_selectedEvent_c).val

            console.log(this.store_questEvent.qev_questType_e)
            console.log(this.store_questEvent.qev_questId_uid)
            console.log(this.store_questEvent.qev_eventId_uid)

            // 0) set listener to questEvent
            server_questEvent_vl_set_f(this.$options.name, this.store_questEvent.qev_questType_e, this.store_questEvent.qev_questId_uid, this.store_questEvent.qev_eventId_uid,
                (questEvent_c) => {

                    // check that quest exist
                    if(questEvent_c == null){
                        route_moveToRoute(enum_moveToOptions.creator_events_list)
                        return
                    }

                    this.server_questEvent_c = questEvent_c

                    if(this.server_creatorData_c == null){
                        serverAuth_getOtherUserData_f(this.server_questEvent_c.qev_creatorId_uid, (creatorData_c) => {
                            this.server_creatorData_c = creatorData_c
                        })
                    }

                    for(let ticketId in questEvent_c.qev_ticketsStatus_byTicketId_b){

                        // already listen to this ticket
                        if(helper_getObjIndexInArray_fn(this.server_questTickets_ac, 'qt_ticketId_uid', ticketId) < 0){

                            // 0.1) get tickets
                            server_questTicket_vl_set(this.$options.name, ticketId, false, questTicket_c => {

                                let index = helper_getObjIndexInArray_fn(this.server_questTickets_ac, 'qt_ticketId_uid', questTicket_c.qt_ticketId_uid)
                                if(index > -1){
                                    this.server_questTickets_ac.splice(index,1,questTicket_c)
                                } else{
                                    // 0.2) get usersData
                                    this.server_questTickets_ac.push(questTicket_c)

                                    serverAuth_getOtherUserData_f(questTicket_c.qt_playerId_uid,
                                        (userData_c) =>{

                                            this.$set(this.server_usersData_byUserId, userData_c.ud_userId_uid, userData_c)
                                        })

                                }
                            })
                        }
                    }
            })

            // 1) get quest body
            serverBig_questBody_once_fp(this.store_questEvent.qev_questType_e, this.store_questEvent.qev_questId_uid, false,false, questBody_c => {
                this.server_questBody_c = questBody_c;

                // set lastSelectedObservableTeams
                this.m_initLastCachedObservableTeams_f()
            })

            // 2.0) get quest explore
            serverBig_questExplore_once_f(this.store_questEvent.qev_questId_uid, false, (questExplore) => {
                this.server_questExplore_c = questExplore

                // 2.1) valueListener creatorMonthlyTicket
                server_creatorMonthlyTickets_vl_set({
                    viewName_s: this.$options.name,
                    userId_uid: questExplore.qex_creatorId_uid,
                    cb_f : (creatorMonthlyTickets_c) => {
                        this.server_creatorMonthlyTickets_c =  creatorMonthlyTickets_c
                    }
                })

                // 2.2) subscriptionPlanInfo
                serverPre_subUserData_subscriptionPlanInfo_get_f({
                    userId_uid : questExplore.qex_creatorId_uid,
                    cb_f : (subPlanInfo_c)=>{
                        this.server_subPlanInfo_c = subPlanInfo_c
                    }
                })
            })

            // 3.0) get currentUserData
            serverAuth_currentUserData_get_vl_fp(this.$options.name, (currentUserData_c) => {

                if(!currentUserData_c){
                    return
                }

                this.server_currentUserData_c = currentUserData_c

                // 3.1) get quest game status
                serverOngoing_gameStatus_vl_set_f(this.$options.name, this.store_questEvent.qev_questType_e, this.store_questEvent.qev_questId_uid, this.store_questEvent.qev_eventId_uid, false,
                    (gameStatus_c) => {


                        // remove teams that have been removed
                        if(this.server_gameStatus_c != null){
                            for(let teamId_uid in this.server_gameStatus_c.gs_teams_byTeamId){

                                if(gameStatus_c.gs_teams_byTeamId[teamId_uid] === null){
                                    this.m_toggleObserveTeam_f(teamId_uid)
                                }

                            }
                        }

                        this.server_gameStatus_c = gameStatus_c

                        obj_forEach_f(gameStatus_c.gs_teams_byTeamId, (gs_team_c) => {

                            obj_forEach_f(gs_team_c.gst_players_byUserId_c, (gst_player_c) => {

                                if(this.server_usersData_byUserId[gst_player_c.gstp_playerId_uid] == null){

                                    serverAuth_getOtherUserData_f(gst_player_c.gstp_playerId_uid,
                                        (userData_c) => {
                                            this.$set(this.server_usersData_byUserId, gst_player_c.gstp_playerId_uid, userData_c)
                                        })

                                    serverOngoing_playerMoreInfo_vl_set_f(
                                        this.$options.name,
                                        this.store_questEvent,
                                        gst_player_c.gstp_playerId_uid,
                                        (playerMoreInfo =>{
                                            this.$set(this.server_playersMoreInfo_byUserId_c, gst_player_c.gstp_playerId_uid, playerMoreInfo)
                                        }))
                                }

                            })
                        })


                        this.m_initLastCachedObservableTeams_f()

                    })

            })

            // 4) get quest saved messages
            serverOngoing_savedMsg_getOnce_f(this.store_questEvent, (savedMessages_byTimestamp_c) => {
                this.server_savedMessages_byTimestamp_c = savedMessages_byTimestamp_c
            })




        },
        deactivated(){


            // 1) remove currentUserData
            serverAuth_currentUserData_remove_vl_f(this.$options.name)

            //2) remove ongoing Player more info
            obj_forEach_f(this.server_playersMoreInfo_byUserId_c, (playerMoreInfo_c, playerId_uid) => {
                serverOngoing_playerMoreInfo_vl_remove_f(this.$options.name, this.store_questEvent,playerId_uid)
            })

            // 3) remove game status
            serverOngoing_gameStatus_vl_remove_f(this.$options.name, this.store_questEvent)

            // 4) remove team listeners
            this.selectedObserveTeamsId_as.forEach(teamId_uid => {
                this.m_removeListenersTeam_f(teamId_uid)
            });

            // 5) remove questEvent listener
            server_questEvent_vl_remove_f(
                this.$options.name,
                this.store_questEvent.qev_questType_e,
                this.store_questEvent.qev_questId_uid,
                this.store_questEvent.qev_eventId_uid)

            // 6) remove ticket listener
            for(let ticketId_uid in this.server_questEvent_c.qev_ticketsStatus_byTicketId_b){
                server_questTicket_vl_remove(this.$options.name, ticketId_uid)
            }


            if(this.server_currentUserData_c != null){
                server_creatorMonthlyTickets_vl_remove({viewName_s: this.$options.name, userId_uid: this.server_currentUserData_c.ud_userId_uid})

            }


        }
    }

</script>

<style scoped lang="scss">



</style>